import { FormDataGetStats } from '@/form/form-data/FormDataGetStats';
import { GetStats } from '@/service-data/stats/GetStats';
import { storeService } from '@/services';
import { statsService } from '@/services/stats';
import vuexStore from '@/vuex-store';
import { defineStore } from 'pinia';
import { computed, ref, } from 'vue';
import { BusinessError } from '@/error';
import { userGetterType } from '@/vuex-store/user/getters';
import { whereOperators } from '@/lib/query-parameter/filter';
/** 초기화 되지 않는 데이터 */
export const prevData = {
    pageSizeType: '',
    pageNumber: 0,
};
// 통계 (상점, 허브 공통 사용)
export const piniaStats = defineStore('stats', () => {
    // STATE
    const formData = ref(new FormDataGetStats());
    /** 원본 폼 데이터 (초기화에서 사용) */
    const originFormData = ref(new FormDataGetStats());
    /** 허브 리스트 */
    /** 통계 데이터 */
    const statsData = ref([]);
    /** 상점 리스트 */
    const storeList = ref([]);
    /** 서브컨틀롤러의 캘린더 타입 */
    const calType = ref('');
    /** 허브 또는 상점 타입 */
    const hubStoreType = ref('');
    /** 총 데이터 */
    const totalData = ref({});
    /** 통계 데이터 */
    const statsSeriesData = ref([]);
    /** 선택된 통계 타입, 매출금액, 평균금액, 건수 */
    const selectedChartType = ref('sales');
    /** 통계 인스턴스 */
    const thisStatsInstance = ref(null);
    /** 월별 기간 최대 개월 수 */
    const maxPeriodMonthly = ref(2);
    /** 기간 최대 일자 */
    const maxPeriod = ref(31);
    /** 최소 날짜 */
    const minDate = ref('');
    /** 최대 날짜 */
    const maxDate = ref('');
    /** 캘린더 다이얼로그의 날짜 출력용 날짜 데이터 */
    const datePickerDate = ref([]);
    /** 그래프 옵션 */
    const chartOptions = ref({});
    // COMPUTED
    /** comp 상점 리스트 */
    const compStoreList = computed(() => [
        {
            code: 'ALL',
            name: '전체 상점',
        },
        ...storeList.value,
    ]);
    /**
     * 허브 리스트
     */
    const hubList = computed(() => {
        const _hubList = vuexStore.state.hubSelector.hubs;
        // 상점 통계 타입에서는 전체허브 필요 없음
        if (hubStoreType.value === 'store') {
            return _hubList;
        }
        return [
            {
                key: 'ALL',
                text: '전체 허브',
            },
            ..._hubList,
        ];
    });
    // ACTION
    /** 통계 데이터 초기화 */
    const clearStatsData = () => {
        formData.value.selectedHub = vuexStore.getters[userGetterType.hubId];
        formData.value.selectedStore = 'ALL';
        formData.value.allOrB2b = 'all';
        formData.value.orderOrShare = 'order';
        formData.value.statsType = thisStatsInstance.value.statsType;
        formData.value.resourceType = thisStatsInstance.value.resourceType;
        formData.value.date = thisStatsInstance.value.makeInitDate();
        datePickerDate.value = [
            ...formData.value.date,
        ];
        maxDate.value = formData.value.date?.[1];
        statsData.value = [];
        statsSeriesData.value = [];
        totalData.value = {};
    };
    /**
     * 통계 조회
     */
    const getStats = async () => {
        const response = await statsService.getStats(new GetStats(formData.value));
        statsData.value = response.list;
        totalData.value = thisStatsInstance.value.makeTotalData(response.list);
    };
    /**
     * 상점 리스트
     */
    const getStoreList = async () => {
        const filters = [];
        filters.push({
            condition: whereOperators.equals,
            field: 'hubId',
            value: formData.value.selectedHub,
        });
        try {
            const response = await storeService.getStoreList({
                filters,
            });
            storeList.value = response.list;
        }
        catch (error) {
            if (error instanceof BusinessError) {
                console.log(error);
            }
        }
    };
    /**
     * 서브컨트롤러 초기화
     */
    const initSubControllerType = () => {
        calType.value = thisStatsInstance.value.dateType;
    };
    return {
        totalData,
        formData,
        originFormData,
        statsData,
        hubList,
        storeList,
        compStoreList,
        getStats,
        getStoreList,
        initSubControllerType,
        calType,
        hubStoreType,
        statsSeriesData,
        selectedChartType,
        thisStatsInstance,
        clearStatsData,
        maxPeriodMonthly,
        maxPeriod,
        minDate,
        maxDate,
        datePickerDate,
        chartOptions,
    };
});
